export default "__VITE_ASSET__308a8b3c__"